import { useApiQuery } from '../useApiQuery';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { Lead } from '@/types/lead';

export function useLead(id: string, options?: { enabled?: boolean }) {
  return useApiQuery<Lead>({
    queryKey: leadKeys.detail(id),
    queryFn: () => apiGet<Lead>(operationsClient, leadEndpoints.detail(id)),
    enabled: Boolean(id) && (options?.enabled ?? true),
    showErrorToast: false,
  });
}
